import { Action } from '../../definitions/types';
import {
  GENERAL_SERVER_ERROR,
  INVALID_USER_ACCOUNT_ID_TOKEN,
  INVALID_USER_ID_TOKEN,
} from '../reducers/error';
import * as actions from './actions-consts';

export interface ErrorPayload {
  error: string;
}

export function generalRequestFail(): Action<ErrorPayload> {
  return {
    type: actions.GENERAL_REQUEST_FAILED,
    payload: { error: GENERAL_SERVER_ERROR },
    meta: {
      tracked: { action: 'general-request', label: 'fail' },
    },
    error: true,
  };
}

export function loginLinkFailed(): Action<void> {
  return {
    type: actions.LOGIN_LINK_FAILED,
    meta: {
      tracked: { action: 'login-link', label: 'fail' },
    },
    error: true,
  };
}

export function invalidUserIdToken(): Action<ErrorPayload> {
  return {
    type: actions.INVALID_USER_ID_TOKEN,
    payload: { error: INVALID_USER_ID_TOKEN },
    meta: {
      tracked: { action: 'user-id-token', label: 'invalid' },
    },
    error: true,
  };
}

export function unsetGlobalError(): Action<void> {
  return {
    type: actions.UNSET_GLOBAL_ERROR,
  };
}

// TODO cleanup GRW-1410 GRW-1416
export function tosAcceptanceFailed(): Action<ErrorPayload> {
  return {
    type: actions.TOS_ACCEPTANCE_FAILED,
    payload: { error: INVALID_USER_ACCOUNT_ID_TOKEN },
    meta: {
      tracked: { action: 'user-account-id-token', label: 'invalid' },
    },
    error: true,
  };
}
